import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "MonacoReadonly" }
const _hoisted_2 = {
  class: "monaco-readonly-container",
  ref: "editorElement"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "monaco-editor-events-catcher",
      onKeypress: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      onKeyup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
      onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */)
    ], 32 /* HYDRATE_EVENTS */)
  ]))
}